import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ShieldCheck = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.8816 3.41035C11.0322 5.02367 8.31082 6.37194 5.98975 6.37194V13.3719C5.98975 15.6079 6.76054 17.233 7.9765 18.4783C9.21968 19.7516 10.9735 20.6717 12.9862 21.3667L13.0087 21.3748C15.0138 20.6751 16.7628 19.7533 18.0036 18.4802C19.219 17.2333 19.9897 15.6078 19.9897 13.3719V6.37194C17.6695 6.37194 14.9581 5.03439 13.0978 3.41027C13.0674 3.38522 13.0292 3.37149 12.9897 3.37149C12.9502 3.37149 12.912 3.38525 12.8816 3.41035ZM11.5802 1.89164C11.9731 1.55594 12.4729 1.37149 12.9897 1.37149C13.5066 1.37149 14.0064 1.55594 14.3993 1.89164L14.408 1.89905L14.4079 1.8991C16.0475 3.3325 18.3126 4.37194 19.9897 4.37194C20.5202 4.37194 21.0289 4.58265 21.404 4.95773C21.779 5.3328 21.9897 5.84151 21.9897 6.37194V13.3719C21.9897 16.1361 21.0105 18.2606 19.4359 19.8762C17.8884 21.4638 15.8104 22.5163 13.6589 23.2662L13.6507 23.2691L13.6507 23.269C13.2194 23.4152 12.7514 23.4097 12.3238 23.2539C10.1699 22.5091 8.09254 21.46 6.5455 19.8756C4.96895 18.2609 3.98975 16.136 3.98975 13.3719V6.37194C3.98975 5.84151 4.20046 5.3328 4.57553 4.95773C4.9506 4.58265 5.45931 4.37194 5.98975 4.37194C7.66613 4.37194 9.94136 3.32317 11.5719 1.89883L11.5801 1.89159L11.5802 1.89164ZM16.6969 9.66483C17.0874 10.0554 17.0874 10.6885 16.6969 11.079L12.6969 15.079C12.3063 15.4696 11.6732 15.4696 11.2826 15.079L9.28264 13.079C8.89212 12.6885 8.89212 12.0554 9.28264 11.6648C9.67316 11.2743 10.3063 11.2743 10.6969 11.6648L11.9897 12.9577L15.2826 9.66483C15.6732 9.27431 16.3063 9.27431 16.6969 9.66483Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
